const download = {
  downloadReport: 'تحميل التقرير',
  downloadReportLabel: 'جديد',
  downloadTooltipLabel:
    'يمكنك الآن إنشاء تقرير مخصص بناءً على احتياجاتك. تعرف على المزيد عن طريق النقر فوق زر التنزيل.',
};

export default download;
